import React, { useState, useEffect } from 'react'; 
import Headerone from '../headerone/newMain' 
import ScriptLoader from '../mencontact/scriptLoader'; 

function Conference() {
 


  return (
    <>
      <ScriptLoader />
      <Headerone />
        <div className='conferencebanner'>
            <img src='assets/img/chancellor-new_banner.jpg' />
        </div>
       <div className='conference'>
        <div className='container'>
            <div className='row'>
                <div className='col-md-4 col-sm-4 col-xs-12'>
                    <a href='/InternationalConference'>
                    <div className="conferenceblock">
                        <div className='image'>
                            <img src='assets/img/conference-1.jpg' />
                        </div>
                        <h4>4th International Conference</h4>
                        <label>14-15 November, 2025</label>
                    </div>
                    </a>
                </div>
            </div>
        </div>
       </div>

    </>
  )
}

export default Conference

 